/**
 * @file Point d'entree Vite : charge les styles, demarre l'App, affiche une erreur lisible si le demarrage echoue (ex. TODO restants).
 */
import './ui/styles/main.css';
import { App } from '@app/App';
import { initNative } from '@app/native';
import { registerPwa } from '@app/pwa';

const showFatal = (err: unknown): void => {
  console.error(err);
  const root = document.getElementById('ui-root') ?? document.body;
  const box = document.createElement('pre');
  box.className = 'fatal';
  box.textContent = `Cat Gunner v2 n'a pas pu demarrer.\n\n${err instanceof Error ? `${err.message}\n${err.stack ?? ''}` : String(err)}`;
  root.append(box);
};

const canvas = document.getElementById('game-canvas');
const uiRoot = document.getElementById('ui-root');
const appEl = document.getElementById('app');
if (!(canvas instanceof HTMLCanvasElement) || !uiRoot || !appEl) {
  showFatal(new Error('index.html: #game-canvas / #ui-root / #app manquants'));
} else {
  App.boot({ canvas, uiRoot, inputSurface: appEl })
    .then(() => initNative())
    .catch(showFatal);
  registerPwa();
}
